import { render, staticRenderFns } from "./TagsAi.vue?vue&type=template&id=187112ba&scoped=true"
import script from "./TagsAi.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsAi.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TagsAi.vue?vue&type=style&index=0&id=187112ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187112ba",
  null
  
)

export default component.exports